import styled from "@emotion/styled";
import { DisplayText } from "components/lib";
import { useWindowSize } from "utils";
import chowbusLogoText from "assets/chowbusLogoText.png";
import { getLanguage } from "auth-provider";

export const FatalError = () => {
  const { height: currentHeight } = useWindowSize();
  const isEn = getLanguage() === "en";
  return (
    <Wrap h={currentHeight} dir={"column"}>
      <img
        src={chowbusLogoText}
        style={{ width: "20rem" }}
        alt="logo pic"
      ></img>
      {isEn ? (
        <>
          <TextLine style={{ marginTop: "1rem" }}>
            The code is invalid or missing.
          </TextLine>
          <TextLine>Please rescan the QR code and try again.</TextLine>
        </>
      ) : (
        <TextLine fontF={"PingFang SC"} style={{ marginTop: "1rem" }}>
          请求参数错误,请重新扫码.{" "}
        </TextLine>
      )}
    </Wrap>
  );
};

const Wrap = styled(DisplayText) <{
  h: number;
}>`
  height: ${(props) => props.h + "px"};
  background-color: #fff;
`;

const TextLine = styled.div<{
  fontF?: string;
}>`
  font-size: 1rem;
  line-height: 1.5rem;
  color: #e00051;
  font-weight: 400;
  font-family: ${(props) => (props.fontF ? props.fontF : "Proxima Nova")};
`;
